<div class="account-benefits">
  <div class="line">
    <img src="./../../../../assets/images/icons/Checkmark-small.svg" alt="checkmar">
    <span>Faster checkout</span>
  </div>
  <div class="line">
    <img src="./../../../../assets/images/icons/Checkmark-small.svg" alt="checkmar">
    <span>Access to order history</span>
  </div>
  <div class="line">
    <img src="./../../../../assets/images/icons/Checkmark-small.svg" alt="checkmar">
    <span>10% discount coupon</span>
  </div>
</div>
